import {includes} from "lodash";

export function parsePageType(pageType) {
  pageType = pageType || "";

  let result =  {
    universal: includes(pageType, 'U'),
    clustered: includes(pageType, 'C'),
    multiAdd: includes(pageType, 'M'),
    fitmentInCluster: includes(pageType, 'f'),
    lloyd: includes(pageType, 'L'),
    watchedFields: ['id']
  };

  // want fitment if NOT fitmentInCluster
  if (!result.fitmentInCluster)
    result.watchedFields.push('fitment');

  if (result.lloyd)
    result.watchedFields.push('lloyd_unique');

  return result;
}
